(function () {
    'use strict';
    var controllerId = 'commessaSezioneAdd';
    angular.module('app').controller(controllerId, ['$rootScope', '$scope', '$uibModalInstance', 'datacontext', 'commessaId', commessaSezioneAddFn]);

    function commessaSezioneAddFn($rootScope, $scope, $uibModalInstance, datacontext, commessaId) {
        $scope.item = {};
        $scope.item.fTesto = '';
        $scope.item.sezioni = getSezioni();
        $scope.item.cerca = getSezioni;
        $scope.item.loading = true;
        $scope.commessaId = commessaId;
        $scope.personale = $rootScope.isAuthorized('PERSONALE');

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.ok = function (isValid) {
            var sezioni = [];
            $("input:checkbox[name=testId]:checked").each(function () {
                sezioni.push($(this).val());
            });           

            addItem($scope.commessaId, sezioni).then(function (result) {
                $uibModalInstance.close(result);
            });
        };

        function getSezioni() {
            $scope.item.loading = true;
            return datacontext.sezione_getAll(0, 0, $scope.item.fTesto, 'codice').then(function (data) {                
                $scope.item.loading = false;
                return $scope.item.sezioni = data;
            });
        }

        function addItem(commessaId, sezioni) {
            return datacontext.commessaSezione_addList(commessaId, sezioni).then(function (data) {
                return data;
            });
        }

        $scope.toggleAll = function () {
            if ($scope.isAllSelected) {
                $("input:checkbox[name=testId]").each(function () {
                    this.checked = true;
                });
            } else {
                $("input:checkbox[name=testId]").each(function () {
                    this.checked = false;
                });
            }
        };
    }
})();